import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardCrm from "../pages/DashboardCrm";
import DashboardEcommerce from "../pages/DashboardEcommerce";
import Dashboardjob from "../pages/Dashboardjob/index"

import DashboardCrypto from "../pages/DashboardCrypto";
import DashboardProject from "../pages/DashboardProject";
import DashboardNFT from "../pages/DashboardNFT";

//Calendar
import MonthGrid from "../pages/Calendar/MonthGrid";
import Calendar from "../pages/Calendar/Maincalender";

// Email box
import MailInbox from "../pages/EmailInbox";
import BasicAction from "../pages/Email/EmailTemplates/BasicAction";
import EcommerceAction from "../pages/Email/EmailTemplates/EcommerceAction";

//Chat
import Chat from "../pages/Chat";

// Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";

//Task
import TaskDetails from "../pages/Tasks/TaskDetails";
import TaskList from "../pages/Tasks/TaskList";
import Kanbanboard from "../pages/Tasks/KanbanBoard";

//Transactions
import Transactions from '../pages/Crypto/Transactions';
import BuySell from '../pages/Crypto/BuySell';
import CryproOrder from '../pages/Crypto/CryptoOrder';
import MyWallet from '../pages/Crypto/MyWallet';
import ICOList from '../pages/Crypto/ICOList';
import KYCVerification from '../pages/Crypto/KYCVerification';

//Crm Pages
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CrmContacts from "../pages/Crm/CrmContacts";
import CrmDeals from "../pages/Crm/CrmDeals/index";
import CrmLeads from "../pages/Crm/CrmLeads/index";

//Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";
import OrderInvoice from "../SNPages/PersonalCenter/Order/OrderInvoice";
import CODManagement from "../SNPages/PersonalCenter/Order/CODManagement";

// Support Tickets
import ListView from '../pages/SupportTickets/ListView';
import TicketsDetails from '../pages/SupportTickets/TicketsDetails';

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceSellers from "../pages/Ecommerce/EcommerceSellers/index";
import EcommerceSellerDetail from "../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail";

// NFT Marketplace Pages
import Marketplace from "../pages/NFTMarketplace/Marketplace";
import Collections from "../pages/NFTMarketplace/Collections";
import CreateNFT from "../pages/NFTMarketplace/CreateNFT";
import Creators from "../pages/NFTMarketplace/Creators";
import ExploreNow from "../pages/NFTMarketplace/ExploreNow";
import ItemDetails from "../pages/NFTMarketplace/Itemdetails";
import LiveAuction from "../pages/NFTMarketplace/LiveAuction";
import Ranking from "../pages/NFTMarketplace/Ranking";
import WalletConnect from "../pages/NFTMarketplace/WalletConnect";

// Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiLinks from "../pages/BaseUi/UiLinks/UiLinks";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// Advance Ui
import UiNestableList from "../pages/AdvanceUi/UiNestableList/UiNestableList";
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// Widgets
import Widgets from '../pages/Widgets/Index';

//Forms
import BasicElements from "../pages/Forms/BasicElements/BasicElements";
import FormSelect from "../pages/Forms/FormSelect/FormSelect";
import FormEditor from "../pages/Forms/FormEditor/FormEditor";
import CheckBoxAndRadio from "../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio";
import Masks from "../pages/Forms/Masks/Masks";
import FileUpload from "../pages/Forms/FileUpload/FileUpload";
import FormPickers from "../pages/Forms/FormPickers/FormPickers";
import FormRangeSlider from "../pages/Forms/FormRangeSlider/FormRangeSlider";
import Formlayouts from "../pages/Forms/FormLayouts/Formlayouts";
import FormValidation from "../pages/Forms/FormValidation/FormValidation";
import FormWizard from "../pages/Forms/FormWizard/FormWizard";
import FormAdvanced from "../pages/Forms/FormAdvanced/FormAdvanced";
import Select2 from "../pages/Forms/Select2/Select2";

//Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
import ListTables from '../pages/Tables/ListTables/ListTables';
import ReactTable from "../pages/Tables/ReactTables";

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";
import CryptoIcons from "../pages/Icons/CryptoIcons/CryptoIcons";

//Maps
import GoogleMaps from "../pages/Maps/GoogleMaps/GoogleMaps";

//AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
//pages
import Starter from '../pages/Pages/Starter/Starter';
import SimplePage from '../pages/Pages/Profile/SimplePage/SimplePage';
import Settings from '../pages/Pages/Profile/Settings/Settings';
import Team from '../pages/Pages/Team/Team';
import Timeline from '../pages/Pages/Timeline/Timeline';
import Faqs from '../pages/Pages/Faqs/Faqs';
import Pricing from '../pages/Pages/Pricing/Pricing';
import Gallery from '../pages/Pages/Gallery/Gallery';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
// import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import SiteMap from '../pages/Pages/SiteMap/SiteMap';
import SearchResults from '../pages/Pages/SearchResults/SearchResults';

import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from '../pages/AuthenticationInner/Logout/BasicLogout';
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

//Charts
import LineCharts from "../pages/Charts/ApexCharts/LineCharts";
import AreaCharts from "../pages/Charts/ApexCharts/AreaCharts";
import ColumnCharts from "../pages/Charts/ApexCharts/ColumnCharts";
import BarCharts from "../pages/Charts/ApexCharts/BarCharts";
import MixedCharts from "../pages/Charts/ApexCharts/MixedCharts";
import TimelineCharts from "../pages/Charts/ApexCharts/TimelineCharts";
import RangeAreaCharts from "../pages/Charts/ApexCharts/RangeAreaCharts/index";
import FunnelCharts from "../pages/Charts/ApexCharts/FunnelCharts";
import CandlestickChart from "../pages/Charts/ApexCharts/CandlestickChart";
import BoxplotCharts from "../pages/Charts/ApexCharts/BoxplotCharts";
import BubbleChart from "../pages/Charts/ApexCharts/BubbleChart";
import ScatterCharts from "../pages/Charts/ApexCharts/ScatterCharts";
import HeatmapCharts from "../pages/Charts/ApexCharts/HeatmapCharts";
import TreemapCharts from "../pages/Charts/ApexCharts/TreemapCharts";
import PieCharts from "../pages/Charts/ApexCharts/PieCharts";
import RadialbarCharts from "../pages/Charts/ApexCharts/RadialbarCharts";
import RadarCharts from "../pages/Charts/ApexCharts/RadarCharts";
import PolarCharts from "../pages/Charts/ApexCharts/PolarCharts";

import ChartsJs from "../pages/Charts/ChartsJs/index";
import Echarts from "../pages/Charts/ECharts/index";

// Landing Index
import OnePage from "../pages/Landing/OnePage";
import NFTLanding from "../pages/Landing/NFTLanding";
import JobsLanding from "../pages/Job_Landing"

// User Profile
import UserProfile from "../pages/Authentication/user-profile";

import FileManager from "../pages/FileManager";
import ToDoList from "../pages/ToDo";
import PrivancyPolicy from "../pages/Pages/PrivancyPolicy/PrivancyPolicy";
import TermAndConditions from "../pages/Pages/TermAndConditions/TermAndConditions";

import Statistics from "../pages/Jobs/Statistics";
import JobList from "../pages/Jobs/JobList/List";
import JobGrid from "../pages/Jobs/JobList/Grid";
import JobOverview from "../pages/Jobs/JobList/Overview";
import CandidateList from "../pages/Jobs/CandidateList/ListView";
import CandidateGrid from "../pages/Jobs/CandidateList/GridView";
import NewJobs from "../pages/Jobs/NewJob";
import JobCategories from "../pages/Jobs/JobCategories";
import Application from "../pages/Jobs/Application";
import CompaniesList from "../pages/Jobs/CompaniesList";

//APi Key
import APIKey from "../pages/APIKey/index";
import DashboardBlog from "../pages/DashboardBlog";
import SlopeCharts from "../pages/Charts/ApexCharts/SlopeCharts";
import BlogListView from "../pages/Pages/Blogs/ListView";
import BlogGridView from "../pages/Pages/Blogs/GridView";
import PageBlogOverview from "../pages/Pages/Blogs/Overview";


//SNPages
import SNLogin from "../SNPages/Authentication/Login";
import SNLogout from "../SNPages/Authentication/Logout";
import SNAboutUS from "../SNPages/Authentication/AboutUS";
import HelpAndSupport from "../SNPages/Authentication/HelpAndSupport";
import SNRegister from "../SNPages/Authentication/Register"; 
import SNProfileSimplePage from "../SNPages/Authentication/Profile/SimplePage"
import SNProfileSettings from "../SNPages/Authentication/Profile/Settings"
import CognitoLogin from "../SNPages/Authentication/CognitoLogin";
import CognitoLoginSimple from "../SNPages/Authentication/CognitoLoginSimple";
import OAuthCallback from "../SNPages/Authentication/OAuthCallback";
import OAuthDebug from "../SNPages/Authentication/OAuthDebug";
import GoogleOAuthCallback from "../SNPages/Authentication/GoogleOAuthCallback";
import CognitoTest from "../SNPages/Authentication/CognitoTest";
import PublicActivity from "../SNPages/PublicActivity/ActivityList";
import PublicActivityDetail from "../SNPages/PublicActivity/ActivityDetail"; 
import ComingSoon from "../SNPages/ComingSoon" 
import ScanProducts from "../SNPages/ScanProducts/Index"

//SNAuthInner
import SNBasicSignIn from '../SNPages/AuthenticationInner/Login/BasicSignIn';
import SNCoverSignIn from '../SNPages/AuthenticationInner/Login/CoverSignIn';
import SNBasicSignUp from '../SNPages/AuthenticationInner/Register/BasicSignUp';
import SNCoverSignUp from "../SNPages/AuthenticationInner/Register/CoverSignUp";
import SNBasicPasswReset from '../SNPages/AuthenticationInner/PasswordReset/BasicPasswReset';
import SNCoverPasswReset from '../SNPages/AuthenticationInner/PasswordReset/CoverPasswReset';
import SNBasicLockScreen from '../SNPages/AuthenticationInner/LockScreen/BasicLockScr';
import SNCoverLockScreen from '../SNPages/AuthenticationInner/LockScreen/CoverLockScr';
import SNBasicLogout from '../SNPages/AuthenticationInner/Logout/BasicLogout';
import SNCoverLogout from '../SNPages/AuthenticationInner/Logout/CoverLogout';
import SNBasicSuccessMsg from '../SNPages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import SNCoverSuccessMsg from '../SNPages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import SNBasicTwosVerify from '../SNPages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import SNCoverTwosVerify from '../SNPages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import SNBasic404 from '../SNPages/AuthenticationInner/Errors/Basic404';
import SNCover404 from '../SNPages/AuthenticationInner/Errors/Cover404';
import SNAlt404 from '../SNPages/AuthenticationInner/Errors/Alt404';
import SNError500 from '../SNPages/AuthenticationInner/Errors/Error500';
import SNBasicPasswCreate from "../SNPages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import SNCoverPasswCreate from "../SNPages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
//SNPages-PerSonalCenter
import BaseInfo from "../SNPages/PersonalCenter/PersonalInfo/BaseInfo"
import MemberInfo from "../SNPages/PersonalCenter/PersonalInfo/MemberInfo"

import OrderList from "../SNPages/PersonalCenter/Order/OrderList"
import OrderDetail from "../SNPages/PersonalCenter/Order/OrderDetail"
import OrderAfterSales from "../SNPages/PersonalCenter/Order/OrderAfterSales"
import OrderProduct from "../SNPages/PersonalCenter/Order/OrderProduct"

import UserAgreement from "../SNPages/PersonalCenter/Agreement/UserAgreement"
import PrivacyAgreement from "../SNPages/PersonalCenter/Agreement/PrivacyAgreement";
//SNPages-Collect
import CollectList from "../SNPages/PersonalCenter/Collect/CollectList"
import CollectDetail from "../SNPages/PersonalCenter/Collect/CollectDetail"
import MyPoints from "../SNPages/PersonalCenter/Points/MyPoints"
import PointsAcquisition from "../SNPages/PersonalCenter/Points/PointsAcquisition"
import PointsMall from "../SNPages/PersonalCenter/Points/Mall"
import PointsMallDetail from "../SNPages/PersonalCenter/Points/Mall/PointsMallDetail"
//SNPages-Address
// import AddressList from "../SNPages/PersonalCenter/Address/AddressList"
//SNPages-Setting
import ChangeTheme from "../SNPages/PersonalCenter/Setting/ChangeTheme"
import ForgetPassword from "../SNPages/PersonalCenter/Setting/ForgetPassword"
import VerificationCode from "../SNPages/PersonalCenter/Setting/VerificationCode"
import ChangePassword from "../SNPages/PersonalCenter/Setting/ChangePassword"

//SNPages-Activity-Manager
import Event from "../SNPages/Event"
import EventDetail from "../SNPages/Event/Detail"

//SNPages-cart
import MyCart from "../SNPages/Cart/CartList"
import CheckOut from "../SNPages/Cart/CheckOut"
import DeliveryAddList from "../SNPages/Cart/DeliveryAddList"
//SNPages-Analysis
import KPI from "../SNPages/Analysis/kPI";
import SalesReport from "../SNPages/Analysis/SalesReport";

//SNPages-chat
import SNChat from "../SNPages/Chat"; 
import SNChatPersonalInfo from "../SNPages/Chat/PersonalInfo"; 

///SNPages-ClockIn
import ClockIn from "../SNPages/ClockIn"; 
import ClockInList from "../SNPages/ClockIn/ClockInList"; 

//SNPages=Custom
import Customs from "../SNPages/Customs"
import CustomsDetail from "../SNPages/Customs/Detail"

//SNPages-Employees
import Employees from "../SNPages/Employees"
import EmployeesDetail from "../SNPages/Employees/Detail"
import EmployeesApprove from "../SNPages/Employees/approve"
import EmployeeSearch from "../SNPages/Employees/EmployeeSearch"


import Users from "../SNPages/Users"
import UserDetail from "../SNPages/Users/Detail"
import UserApprove from "../SNPages/Users/approve"

//SNPages-HomePage-ProductInfo
import HomePage from "../SNPages/HomePage/Index" 


//SNPages-Notifications
import Notifications from "../SNPages/Notifications";
import NotificationsNews from "../SNPages/Notifications/News"

//SNPages-Projects 
import ProductsList from "../SNPages/Products/List"
import MyProductsList from "../SNPages/Products/MyList"
import SNProductDetail from "../SNPages/Products/ProductDetail"
import SNAddProduct from "../SNPages/Products/AddProduct"
import SNEditProduct from "../SNPages/Products/EditProduct"

//SNPages-Schedule
import Schedule from "../SNPages/Schedule"
import ApplyTransfer from "../SNPages/Schedule/ApplyTransfer"
import TransferList from "../SNPages/Schedule/TransferList"

//SNPages-System
import AppSetting from "../SNPages/System/AppSetting";
import AuthoritySetting from "../SNPages/System/AuthoritySetting"

//SNPages-Tasks
import SNTaskList from "../SNPages/Tasks/TaskList"
import SNTaskDetails from "../SNPages/Tasks/TaskDetails"
import SNKanbanBoard from "../SNPages/Tasks/KanbanBoard"

//SNPages-Training
import Training from "../SNPages/Training"
import Examine from "../SNPages/Training/Examine"
import ResourceLibrary from "../SNPages/Training/ResourceLibrary"


//snpages- Calendar
import SNMonthGrid from "../SNPages/Calender/MonthGrid";
import SNCalender from "../SNPages/Calender/Maincalender";
import RegistrationsList from "../SNPages/Event/RegistrationsList";


import OrderManage from "../SNPages/PersonalCenter/Order/OrderManage"
import Home from "../SNPages/ComingSoon/home"

import SNDashboard from "../SNPages/Dashboards"
import SNDashboardEcommerce from "../SNPages/DashboardEcommerce"
import CompanySetting from "../SNPages/OEM/CompanySetting"
import SimpleCompany from "../SNPages/OEM/SimpleCompany"
import OEMList from "../SNPages/OEM/OEMList"
import Avatar from "../SNPages/Authentication/Profile/Avatar"

import InventoryList from "../SNPages/inventory"


const authProtectedRoutes = [
  { path: "/dashboard-analytics", component: <DashboardAnalytics /> },
  { path: "/dashboard-crm", component: <DashboardCrm /> },
  { path: "/sales", component: <SNDashboardEcommerce /> },
  
  { path: "/dashboard", component: <SNDashboard /> },
  { path: "/dashboard-jobs", component: <Dashboardjob /> },
  { path: "/index", component: <DashboardEcommerce /> },
  { path: "/dashboard-crypto", component: <DashboardCrypto /> },
  { path: "/dashboard-projects", component: <DashboardProject /> },
  { path: "/dashboard-nft", component: <DashboardNFT /> },
  { path: "/dashboard-blog", component: <DashboardBlog /> },  

  { path: "/apps-calendar", component: <Calendar /> },
  { path: "/apps-calendar-month-grid", component: <MonthGrid /> },
  { path: "/apps-ecommerce-products", component: <EcommerceProducts /> },
  { path: "/apps-ecommerce-product-details", component: <EcommerceProductDetail /> },
   { path: "/apps-ecommerce-add-product", component: <EcommerceAddProduct /> },
   { path: "/apps-ecommerce-orders", component: <EcommerceOrders /> },
   { path: "/apps-ecommerce-order-details", component: <EcommerceOrderDetail /> },
  { path: "/apps-ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/apps-ecommerce-cart", component: <EcommerceCart /> },
  { path: "/apps-ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/apps-ecommerce-sellers", component: <EcommerceSellers /> },
  { path: "/apps-ecommerce-seller-details", component: <EcommerceSellerDetail /> },
  { path: "/apps-file-manager", component: <FileManager /> },
  { path: "/apps-todo", component: <ToDoList /> },

  { path: "/apps-job-statistics", component: <Statistics /> },
  { path: "/apps-job-lists", component: <JobList /> },
  { path: "/apps-job-grid-lists", component: <JobGrid /> },
  { path: "/apps-job-details", component: <JobOverview /> },
  { path: "/apps-job-candidate-lists", component: <CandidateList /> },
  { path: "/apps-job-candidate-grid", component: <CandidateGrid /> },
  { path: "/apps-job-application", component: <Application /> },
  { path: "/apps-job-new", component: <NewJobs /> },
  { path: "/apps-job-companies-lists", component: <CompaniesList /> },
  { path: "/apps-job-categories", component: <JobCategories /> },


  //Chat
  { path: "/apps-chat", component: <Chat /> },

  //EMail
  { path: "/apps-mailbox", component: <MailInbox /> },
  { path: "/apps-email-basic", component: <BasicAction /> },
  { path: "/apps-email-ecommerce", component: <EcommerceAction /> },

  //Projects
  { path: "/apps-projects-list", component: <ProjectList /> },
  { path: "/apps-projects-overview", component: <ProjectOverview /> },
  { path: "/apps-projects-create", component: <CreateProject /> },

  //Task
  { path: "/apps-tasks-list-view", component: <TaskList /> },
  { path: "/apps-tasks-details", component: <TaskDetails /> },
  { path: "/apps-tasks-kanban", component: <Kanbanboard /> },

  //Crm
  { path: "/apps-crm-contacts", component: <CrmContacts /> },
  { path: "/apps-crm-companies", component: <CrmCompanies /> },
  { path: "/apps-crm-deals", component: <CrmDeals /> },
  { path: "/apps-crm-leads", component: <CrmLeads /> },

  //Invoices
  { path: "/apps-invoices-list", component: <InvoiceList /> },
  { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  { path: "/order-invoice", component: <OrderInvoice /> },
  { path: "/cod-management", component: <CODManagement /> },
  { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  //Supports Tickets
  { path: "/apps-tickets-list", component: <ListView /> },
  { path: "/apps-tickets-details", component: <TicketsDetails /> },

  // //transactions
  { path: "/apps-crypto-transactions", component: <Transactions /> },
  { path: "/apps-crypto-buy-sell", component: <BuySell /> },
  { path: "/apps-crypto-orders", component: <CryproOrder /> },
  { path: "/apps-crypto-wallet", component: <MyWallet /> },
  { path: "/apps-crypto-ico", component: <ICOList /> },
  { path: "/apps-crypto-kyc", component: <KYCVerification /> },

  // NFT Marketplace
  { path: "/apps-nft-marketplace", component: <Marketplace /> },
  { path: "/apps-nft-collections", component: <Collections /> },
  { path: "/apps-nft-create", component: <CreateNFT /> },
  { path: "/apps-nft-creators", component: <Creators /> },
  { path: "/apps-nft-explore", component: <ExploreNow /> },
  { path: "/apps-nft-item-details", component: <ItemDetails /> },
  { path: "/apps-nft-auction", component: <LiveAuction /> },
  { path: "/apps-nft-ranking", component: <Ranking /> },
  { path: "/apps-nft-wallet", component: <WalletConnect /> },

  // //charts
  // { path: "/charts-apex-line", component: <LineCharts /> },
  // { path: "/charts-apex-area", component: <AreaCharts /> },
  // { path: "/charts-apex-column", component: <ColumnCharts /> },
  // { path: "/charts-apex-bar", component: <BarCharts /> },
  // { path: "/charts-apex-mixed", component: <MixedCharts /> },
  // { path: "/charts-apex-timeline", component: <TimelineCharts /> },
  // { path: "/charts-apex-range-area", component: <RangeAreaCharts /> },
  // { path: "/charts-apex-funnel", component: <FunnelCharts /> },
  // { path: "/charts-apex-candlestick", component: <CandlestickChart /> },
  // { path: "/charts-apex-boxplot", component: <BoxplotCharts /> },
  // { path: "/charts-apex-bubble", component: <BubbleChart /> },
  // { path: "/charts-apex-scatter", component: <ScatterCharts /> },
  // { path: "/charts-apex-heatmap", component: <HeatmapCharts /> },
  // { path: "/charts-apex-treemap", component: <TreemapCharts /> },
  // { path: "/charts-apex-pie", component: <PieCharts /> },
  // { path: "/charts-apex-radialbar", component: <RadialbarCharts /> },
  // { path: "/charts-apex-radar", component: <RadarCharts /> },
  // { path: "/charts-apex-polar", component: <PolarCharts /> },
  // { path: "/charts-apex-slope", component: <SlopeCharts /> },

  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-echarts", component: <Echarts /> },


  // // Base Ui
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badges", component: <UiBadges /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-links", component: <UiLinks /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-tabs", component: <UiTabs /> },
  { path: "/ui-accordions", component: <UiAccordions /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progress", component: <UiProgress /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-media", component: <UiMediaobject /> },
  { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-lists", component: <UiList /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-ribbons", component: <UiRibbons /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // // Advance Ui
  // { path: "/advance-ui-nestable", component: <UiNestableList /> },
  // { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  // { path: "/advance-ui-animation", component: <UiAnimation /> },
  // { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  // { path: "/advance-ui-ratings", component: <UiRatings /> },
  // { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // // Widgets
  // { path: "/widgets", component: <Widgets /> },

  // // Forms
  { path: "/forms-elements", component: <BasicElements /> },
  { path: "/forms-select", component: <FormSelect /> },
  { path: "/forms-editors", component: <FormEditor /> },
  { path: "/forms-checkboxes-radios", component: <CheckBoxAndRadio /> },
  { path: "/forms-masks", component: <Masks /> },
  { path: "/forms-file-uploads", component: <FileUpload /> },
  { path: "/forms-pickers", component: <FormPickers /> },
  { path: "/forms-range-sliders", component: <FormRangeSlider /> },
  { path: "/forms-layouts", component: <Formlayouts /> },
  { path: "/forms-validation", component: <FormValidation /> },
  { path: "/forms-wizard", component: <FormWizard /> },
  { path: "/forms-advanced", component: <FormAdvanced /> },
  { path: "/forms-select2", component: <Select2 /> },

  // //Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-listjs", component: <ListTables /> },
  // { path: "/tables-react", component: <ReactTable /> },

  // //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  // //Maps
  // { path: "/maps-google", component: <GoogleMaps /> },

  //Pages
  { path: "/pages-starter", component: <Starter /> },
  { path: "/pages-profile", component: <SimplePage /> },
  { path: "/pages-profile-settings", component: <Settings /> },
  { path: "/pages-team", component: <Team /> },
  { path: "/pages-timeline", component: <Timeline /> },
  { path: "/pages-faqs", component: <Faqs /> },
  { path: "/pages-gallery", component: <Gallery /> },
  { path: "/pages-pricing", component: <Pricing /> },
  { path: "/pages-sitemap", component: <SiteMap /> },
  { path: "/pages-search-results", component: <SearchResults /> },
  { path: "/privancy-policy", component: <PrivancyPolicy /> },
  { path: "/term-conditions", component: <TermAndConditions /> },
  { path: "/pages-blog-list", component: <BlogListView /> },
  { path: "/pages-blog-grid", component: <BlogGridView /> },
  { path: "/pages-blog-overview", component: <PageBlogOverview /> },

  // //Api Key
  { path: "/apps-api-key", component: <APIKey /> },

  // //User Profile
  // { path: "/profile", component: <UserProfile /> },



  //SNPages
  { path: "/profile", component: <SNProfileSimplePage /> },
  { path: "/profile-settings", component: <SNProfileSettings /> },
  { path: "/aboutus", component:<SNAboutUS />},
  { path:"/helpAndSupport", component:<HelpAndSupport/>},
  { path:"/product-list", component:<ProductsList/>},
  { path:"/my-product-list", component:<MyProductsList/>},
  { path:"/my-cart", component:<MyCart/>},
  // Checkout route moved to cartProtectedRoutes
  { path:"/delivery-add-list", component:<DeliveryAddList/>},
  { path:"/scan-products", component:<ScanProducts/>},
  { path:"/base-info", component:<BaseInfo />},
  { path:"/member-info",component:<MemberInfo/>}, 
  { path:"/order-manage", component:<OrderManage/>},
  { path:"/order-list", component:<OrderList/>},
  { path:"/order-detail", component:<OrderDetail/>},
  { path:"/order-after-sales",component:<OrderAfterSales/>},
  { path:"/order-product",component:<OrderProduct/>},
  { path:"/collect-list",component:<CollectList/>},
  { path:"/collect-detail",component:<CollectDetail/>},
  { path:"/my-points",component:<MyPoints/>},
  { path:"/points-acquisition",component:<PointsAcquisition/>},
  { path:"/points-mall",component:<PointsMall/>},
  { path:"/points-mall-detail",component:<PointsMallDetail/>},
  // { path:"/address-list",comonent:<AddressList/>},
  { path:"/change-theme",component:<ChangeTheme/>},
  { path:"/event",component:<Event/>},
  { path:"/event-detail",component:<EventDetail/>},
  { path:"/kpi",component:<KPI/>},
  { path:"/sales-report",component:<SalesReport/>},
  { path:"/chat",component:<SNChat/>},
  { path:"/chat-personal-info",component:<SNChatPersonalInfo/>},
  { path:"/clock-in",component:<ClockIn/>},
  { path:"/clock-in-list",component:<ClockInList/>},
  { path:"/sn-customs",component:<Customs/>},
  { path:"/sn-customs-detail",component:<CustomsDetail/>},
  { path:"/user-list",component:<Users/>},
  { path:"/user-detail",component:<UserDetail/>},
  { path:"/user-approve",component:<UserApprove/>},  
  { path:"/employees",component:<Employees/>},
  { path:"/employees-detail",component:<EmployeesDetail/>},
  { path:"/employees-approve",component:<EmployeesApprove/>},
  { path:"/employees-search",component:<EmployeeSearch/>},  
  { path:"/add-product",component:<SNAddProduct/>},
  { path:"/product-detail",component:<SNProductDetail/>},
  { path:"/shedule",component:<Schedule/>},
  { path:"/transferList",component:<TransferList/>},
  { path:"/apply-transfer",component:<ApplyTransfer/>},
  { path:"/app-setting", component:<AppSetting/>},
  { path:"/authority-setting",component:<AuthoritySetting/>},
  { path:"/sn-task-list",component:<SNTaskList/>},
  { path:"/sn-task-detail",component:<SNTaskDetails/>},
  { path:"/sn-task-board",component:<SNKanbanBoard/>},
  { path:"/training",component:<Training/>},
  { path:"/examine",component:<Examine/>},
  { path:"/resourceLibrary",component:<ResourceLibrary/>},
  { path: "/calender", component: <SNCalender /> },
  { path: "/calender-month-grid", component: <SNMonthGrid /> }, 
  { path: "/home", component: <HomePage/>},
  { path: "/company", component: <SimpleCompany/>},
  { path: "/company-setting", component: <CompanySetting/>},
  { path: "/oem-list", component: <OEMList/>},
  { path: "/avatar", component: <Avatar/>},
  { path: "/inventory-list", component: <InventoryList/>},
  { path: "/events/:eventId/registrations", component: <RegistrationsList/>},
  // { path: "/calender", component: <SNCalender /> },
  // { path: "/calender-month-grid", component: <SNMonthGrid /> },



  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name 
];

const publicRoutes = [
  // Authentication Page 
  // { path: "/login-delete", component: <Login /> },

  { path: "", component: <Home /> },
  { path: "/home", component: <HomePage/>},
  { path: "/login", component: <SNLogin /> },
  { path: "/forgot-password", component: <ForgetPassword /> },
  { path: "/verification", component: <VerificationCode /> },
  { path: "/changePassword", component: <ChangePassword /> },
  { path: "/register", component: <SNRegister /> },
  { path: "/login/cognito", component: <CognitoLogin /> },
  { path: "/login/cognito/test", component: <CognitoLoginSimple /> },
  { path: "/auth/callback", component: <OAuthCallback /> },
  { path: "/oauth-debug", component: <OAuthDebug /> },
  { path: "/auth/google/callback", component: <GoogleOAuthCallback /> },
  { path: "/cognito/test", component: <CognitoTest /> },
  { path: "/sn-signin-basic", component: <SNBasicSignIn /> },
  { path: "/sn-signin-cover", component: <SNCoverSignIn /> },
  { path: "/sn-signup-basic", component: <SNBasicSignUp /> },
  { path: "/sn-signup-cover", component: <SNCoverSignUp /> },
  { path: "/sn-pass-reset-basic", component: <SNBasicPasswReset /> },
  { path: "/sn-pass-reset-cover", component: <SNCoverPasswReset /> },
  { path: "/sn-lockscreen-basic", component: <SNBasicLockScreen /> },
  { path: "/sn-lockscreen-cover", component: <SNCoverLockScreen /> },
  { path: "/logout", component: <SNLogout /> },
  { path: "/sn-logout-cover", component: <SNCoverLogout /> },
  { path: "/sn-success-msg-basic", component: <SNBasicSuccessMsg /> },
  { path: "/sn-success-msg-cover", component: <SNCoverSuccessMsg /> },
  { path: "/sn-twostep-basic", component: <SNBasicTwosVerify /> },
  { path: "/sn-twostep-cover", component: <SNCoverTwosVerify /> },
  { path: "/sn-404-basic", component: <SNBasic404 /> },
  { path: "/sn-404-cover", component: <SNCover404 /> },
  { path: "/404-alt", component: <SNAlt404 /> },
  { path: "/sn-500", component: <SNError500 /> },
  { path: "/sn-pass-change-basic", component: <SNBasicPasswCreate /> },
  { path: "/sn-pass-change-cover", component: <SNCoverPasswCreate /> },
  { path: "/sn-privacy-agreement", component: <PrivacyAgreement /> },
  { path: "/sn-user-agreement", component: <UserAgreement /> },


  // //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  // { path: "/auth-signup-basic", component: <BasicSignUp /> },
  // { path: "/auth-signup-cover", component: <CoverSignUp /> },
  // { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  // { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  // { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  // { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  // { path: "/auth-logout-basic", component: <BasicLogout /> },
  // { path: "/auth-logout-cover", component: <CoverLogout /> },
  // { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  // { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  // { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  // { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  // { path: "/auth-404-basic", component: <Basic404 /> },
  // { path: "/auth-404-cover", component: <Cover404 /> },
  // { path: "/auth-404-alt", component: <Alt404 /> },
  // { path: "/auth-500", component: <Error500 /> },
  // { path: "/pages-maintenance", component: <Maintenance /> },
  // { path: "/pages-coming-soon", component: <ComingSoon /> },

  // { path: "/landing", component: <OnePage /> },
  // { path: "/nft-landing", component: <NFTLanding /> },
  // { path: "/jobs-landing", component: <JobsLanding /> },

  // { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  // { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },

  // { path: "/auth-offline", component: <Offlinepage /> },
  { path: "/commingSoon", component: <ComingSoon /> },  
  { path:"/notifications",component:<Notifications/>},
  { path:"/notifications-news",component:<NotificationsNews/>},
  { path: "/public-activity", component:<PublicActivity /> },
  { path: "/public-activity-detail", component:<PublicActivityDetail /> },


  {
    path: "/",
    exact: true,
    component: <Navigate to="/404-alt" />,
  },
  { path: "*", component: <Navigate to="/404-alt" /> },

];

const cartProtectedRoutes = [
  { path: "/check-out", component: <CheckOut /> },
];

export { authProtectedRoutes, publicRoutes, cartProtectedRoutes };